import React, { useContext, useState } from 'react';
import { makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import { ChevronDown } from '@carbon/icons-react';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import {
  CompanyInfoContext,
  CompanyInfoContextValue
} from '../context/CompanyInfoContext';
import { CompanyInfoSection } from './styled';
import PortfolioCard from './PortfolioCard';
import NewBadge from './NewBadge';

const CompanyPortfolio: React.FunctionComponent = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const [showMore, setShowMore] = useState<boolean>(false);
  const { portfolioList, buttonGroup } = useStyles();
  const context = useContext<CompanyInfoContextValue | null>(
    CompanyInfoContext
  );

  if (!context) return null;

  const { partnerInfo } = context;
  const portfolios = [...(partnerInfo?.portfolios ?? [])].reverse();
  const noPortfolios = portfolios.length === 0;
  const firstPage = !matches ? portfolios.slice(0, 4) : portfolios;

  if (noPortfolios) return null;

  return (
    <CompanyInfoSection id="portfolio">
      <div className="section-title">
        <div className="new-column">
          <CustomizedTypography>포트폴리오</CustomizedTypography>
          <NewBadge />
        </div>
      </div>
      <div className={portfolioList}>
        {noPortfolios && (
          <CustomizedTypography className="no-data">
            업데이트 예정
          </CustomizedTypography>
        )}

        {(!showMore ? firstPage : portfolios).map((portfolio) => (
          <PortfolioCard portfolio={portfolio} key={portfolio.id} />
        ))}
      </div>

      {portfolios.length > 4 && !showMore && !matches && (
        <div className={buttonGroup}>
          <CustomizedButton
            variant="contained"
            color="default"
            endIcon={<ChevronDown size={20} />}
            size="large"
            onClick={() => setShowMore(true)}
          >
            더보기
          </CustomizedButton>
        </div>
      )}
    </CompanyInfoSection>
  );
};

export default CompanyPortfolio;

const useStyles = makeStyles((theme) => ({
  portfolioList: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '16px',
    [theme.breakpoints.down('xs')]: {
      whiteSpace: ' nowrap',
      display: 'flex',
      gap: '16px',
      overflowX: 'scroll',
      padding: '16px 16px 16px 0px',
      minWidth: 'calc(100% + 16px)'
    }
  },
  buttonGroup: {
    marginTop: '24px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  }
}));
